<section
  class="summary-cards"
  [attr.aria-label]="'promotions.summary.title' | translate"
  [attr.aria-busy]="isLoading()"
>
  @if (isLoading()) {
    <div class="summary-cards__loader"><korviu-loader></korviu-loader></div>
  } @else {
    @for (card of cards(); track card.key) {
      <article class="summary-card">
        <span class="summary-card__icon" aria-hidden="true">
          <img [src]="'assets/img/promotions/' + card.icon" width="24" height="24" alt="" />
        </span>
        <div class="summary-card__copy">
          <strong>{{ card.value | number: '1.0-0' }}</strong>
          <span>{{ 'promotions.summary.' + card.key | translate }}</span>
        </div>
      </article>
    }
  }
</section>
